import { createFileRoute } from "@tanstack/react-router";
import GutterInstallation from "@/pages/services/GutterInstallation";
import { seo, breadcrumbSchema, absoluteUrl } from "@/lib/seo";
import { buildFaqPageSchema, buildServiceSchema } from "@/lib/schema";
import { gutterInstallationFaqs } from "@/data/serviceFaqs";

export const Route = createFileRoute("/_site/services/gutter-installation")({
  head: () =>
    seo({
      title:
        "Seamless Gutter Installation in Minneapolis, MN | Cedar Creek Construction",
      description:
        "Seamless aluminum gutter installation in Minneapolis & the Twin Cities. Custom-fit, fewer leaks, less maintenance. Free estimates from a licensed local crew: (612) 298-9865.",
      path: "/services/gutter-installation",
      jsonLd: [
        breadcrumbSchema([
          { name: "Home", path: "/" },
          { name: "Services", path: "/gutters" },
          {
            name: "Gutter Installation",
            path: "/services/gutter-installation",
          },
        ]),
        buildServiceSchema({
          name: "Seamless Gutter Installation in Minneapolis, MN",
          serviceType: "Gutter Installation",
          url: absoluteUrl("/services/gutter-installation"),
          description:
            "Custom seamless aluminum gutter and downspout installation for homes across Minneapolis and the Twin Cities metro, installed by a licensed local contractor.",
        }),
        buildFaqPageSchema(gutterInstallationFaqs),
      ],
    }),
  component: GutterInstallation,
});
